import type { MaterialOrderRequestColumn } from '../../types/column-types'

export const amountColumn: MaterialOrderRequestColumn = {
    title: 'Кол-во',
    dataIndex: 'amount',
    width: 90,
    render: (value, record) => {
        const unitName = record.unit ? record.unit.shortName : ''
        return `${value} ${unitName}`
    },
}
